"use client"

import { createContext, useContext } from "react"
import { TModuleFooter } from "@/types/base"

const ConfigContext = createContext<TModuleFooter | null>(null)

export const useConfig = () => useContext(ConfigContext)

export const ConfigProvider = ({
  value,
  children,
}: {
  value: TModuleFooter
  children: React.ReactNode
}) => {
  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  )
}
